import React from "react";
import { Dialog } from "primereact/dialog";

const ReusableModal = ({
  isVisible,
  onClose,
  title = "",
  HeaderIcon = null,
  children,
  footerButtons = null,
  className = "w-full md:w-[600px] lg:w-[700px]",
  position = "center",
  favIcon = null,
}) => {
  const renderHeader = () => (
    <div className="flex justify-between align-items-center">
      <div className="flex items-center">
        {HeaderIcon && (
          <div className="icon-bg-container me-2">
            <HeaderIcon size={20} className="text-iconC" />
          </div>
        )}
        <h5 className="text-darkBg  text-[16px] md:text-[18px] lg:text-[20px] font-[600] capitalize">
          {title}
        </h5>
      </div>
      {favIcon && <div className="mx-4">{favIcon}</div>}
    </div>
  );

  return (
    <Dialog
      position={position}
      visible={isVisible}
      onHide={onClose}
      header={renderHeader()}
      footer={footerButtons}
      className={`${className}  mt-6 lg:mt-[50px]`}
      modal
      draggable={false}
      closable
      pt={{
        closeButton: { className: "icon-bg-container" },
        closebuttonicon: { className: "text-red-500" },
      }}
    >
      {children}
    </Dialog>
  );
};

export default ReusableModal;
